function ajaxPost(action, page, wrapper, terms) {
	// Send an AJAX request using fetch
	fetch(dynmotors_params.ajaxurl, {
		method: "POST",
		headers: {
			"Content-Type": "application/x-www-form-urlencoded",
		},
		body: "action=" + action + "&page=" + page + "&terms=" + terms,
	})
		.then(function (response) {
			return response.text();
		})
		.then(function (data) {
			if (data) {
				// 가상 템플릿 내용 설정
				const template = document.createElement("template");
				template.innerHTML = data;

				// wrapper 내용을 가상 템플릿 내용으로 치환
				wrapper.innerHTML = "";
				wrapper.appendChild(template.content);

				return false;
			}
		})
		.catch(function (error) {
			console.error("Error:", error);
		});
}

// 페이지네이션 클릭 이벤트
function clickPageNumber(action, wrapper) {
	wrapper.addEventListener("click", function (event) {
		const currentNumber = parseInt(wrapper.querySelector(".current").innerHTML);
		const terms = wrapper.dataset.contentsType ?? null;
		const classList = event.target.classList;
		if (classList.contains("page-numbers")) {
			event.preventDefault();
			if (classList.contains("next")) {
				ajaxPost(action, Math.abs(currentNumber + 1), wrapper, terms);
				return false;
			}
			if (classList.contains("prev")) {
				ajaxPost(action, Math.abs(currentNumber - 1), wrapper, terms);
				return false;
			}
			ajaxPost(action, parseInt(event.target.innerHTML), wrapper, terms);
		}
	});
}

document.addEventListener("DOMContentLoaded", function () {
	// home 부분 news 로드시 클릭 이벤트 등록
	const homeNews = document.querySelector(".repeater--only-title");
	if (homeNews) {
		clickPageNumber("home_news", homeNews);
	}

	// contents 부분 클릭 이벤트 등록
	const contents = document.querySelectorAll(".contents__item-container");
	if (contents) {
		contents.forEach((content) => {
			clickPageNumber("contents", content);
		});
	}
});
